// extracted by mini-css-extract-plugin
module.exports = {"RelationCard":"_1NEHHVL2zj6kHf61uqlV6v"};